/**
 * free-shipping-bar.js
 */

(function () {
  "use strict";

  // ── Threshold map (mirrors the Liquid snippet) ──────────────────────────
  const THRESHOLDS = {
    DK: 45000,
    SE: 49900,
    NO: 59900,
    FI: 4990,
    DE: 4990,
    NL: 4990,
    BE: 4990,
    FR: 5990,
    AT: 5990,
    CH: 5990,
    IT: 6990,
    ES: 6990,
    PT: 6990,
    PL: 19900,
    GB: 3990,
    IE: 4990,
    US: 4900,
    CA: 5900,
    AU: 7900,
    NZ: 8900,
    "*": 45000,
  };

  // ── i18n strings ─────────────────────────────────────────────────────────
  const I18N = {
    en: {
      trigger: "Free shipping",
      spend_more: "Spend <strong>{amount}</strong> more for free shipping",
      eligible: "🎉 You've unlocked free shipping!",
    },
    da: {
      trigger: "Gratis fragt",
      spend_more: "Køb for <strong>{amount}</strong> mere og få gratis fragt",
      eligible: "🎉 Du har optjent gratis fragt!",
    },
    sv: {
      trigger: "Gratis frakt",
      spend_more: "Handla för <strong>{amount}</strong> mer och få fri frakt",
      eligible: "🎉 Du har fått fri frakt!",
    },
    nb: {
      trigger: "Gratis frakt",
      spend_more: "Kjøp for <strong>{amount}</strong> mer og få gratis frakt",
      eligible: "🎉 Du har fått gratis frakt!",
    },
    no: {
      trigger: "Gratis frakt",
      spend_more: "Kjøp for <strong>{amount}</strong> mer og få gratis frakt",
      eligible: "🎉 Du har fått gratis frakt!",
    },
    fi: {
      trigger: "Ilmainen toimitus",
      spend_more:
        "Lisää ostoksia <strong>{amount}</strong> verran ilmaisen toimituksen saamiseksi",
      eligible: "🎉 Olet ansainnut ilmaisen toimituksen!",
    },
    de: {
      trigger: "Gratis Versand",
      spend_more: "Noch <strong>{amount}</strong> bis zum kostenlosen Versand",
      eligible: "🎉 Du hast kostenlosen Versand freigeschaltet!",
    },
    nl: {
      trigger: "Gratis verzending",
      spend_more: "Nog <strong>{amount}</strong> voor gratis verzending",
      eligible: "🎉 Je hebt gratis verzending ontgrendeld!",
    },
    fr: {
      trigger: "Livraison gratuite",
      spend_more:
        "Plus que <strong>{amount}</strong> pour la livraison gratuite",
      eligible: "🎉 Vous avez débloqué la livraison gratuite !",
    },
    it: {
      trigger: "Spedizione gratuita",
      spend_more: "Ancora <strong>{amount}</strong> per la spedizione gratuita",
      eligible: "🎉 Hai sbloccato la spedizione gratuita!",
    },
    es: {
      trigger: "Envío gratuito",
      spend_more: "Añade <strong>{amount}</strong> más para envío gratuito",
      eligible: "🎉 ¡Has desbloqueado el envío gratuito!",
    },
    pt: {
      trigger: "Envio gratuito",
      spend_more: "Faltam <strong>{amount}</strong> para envio gratuito",
      eligible: "🎉 Você desbloqueou o envio gratuito!",
    },
    pl: {
      trigger: "Darmowa dostawa",
      spend_more:
        "Dodaj jeszcze <strong>{amount}</strong>, aby uzyskać darmową dostawę",
      eligible: "🎉 Odblokowałeś darmową dostawę!",
    },
  };

  // ── Helpers ──────────────────────────────────────────────────────────────

  function detectLocale() {
    const meta = document.querySelector('meta[name="shopify-locale"]');
    if (meta) return meta.content.slice(0, 2);
    return (document.documentElement.lang || "en").slice(0, 2);
  }

  function getStrings(locale) {
    return I18N[locale] || I18N["en"];
  }

  function formatMoney(cents) {
    const currencyCode =
      (window.Shopify &&
        window.Shopify.currency &&
        window.Shopify.currency.active) ||
      "USD";
    const locale =
      (window.Shopify && window.Shopify.locale) || navigator.language || "en";

    const formatter = new Intl.NumberFormat(locale, {
      style: "currency",
      currency: currencyCode,
    });
    const hasFraction = formatter
      .formatToParts(1)
      .some((p) => p.type === "fraction");

    return new Intl.NumberFormat(locale, {
      style: "currency",
      currency: currencyCode,
      minimumFractionDigits: hasFraction ? 2 : 0,
      maximumFractionDigits: hasFraction ? 2 : 0,
    }).format(cents / (hasFraction ? 100 : 1));
  }

  function getThreshold(countryCode) {
    return THRESHOLDS[countryCode] || THRESHOLDS["*"];
  }

  // ── DOM update ───────────────────────────────────────────────────────────

  function updateBar(cartTotal) {
    const bar = document.querySelector("free-shipping-bar");
    if (!bar) return;

    const country = bar.dataset.country || "*";
    const threshold = getThreshold(country);
    const locale = detectLocale();
    const strings = getStrings(locale);
    const remaining = Math.max(0, threshold - cartTotal);
    const pct = Math.min(100, (cartTotal / threshold) * 100);
    const eligible = cartTotal >= threshold;

    bar.dataset.progress = pct.toFixed(1);
    bar.dataset.eligible = eligible;
    bar.classList.toggle("fsb-wrapper--eligible", eligible);

    // Update trigger label (in case locale changes client-side)
    const triggerText = bar.querySelector(".fsb-trigger__text");
    if (triggerText && strings.trigger)
      triggerText.textContent = strings.trigger;

    // Update popover message
    const msgEl = bar.querySelector(".fsb-message");
    if (msgEl) {
      if (eligible) {
        msgEl.innerHTML = `<span class="fsb-message__eligible">${strings.eligible}</span>`;
      } else {
        msgEl.innerHTML = `<span class="fsb-message__progress">${strings.spend_more.replace(
          "{amount}",
          formatMoney(remaining),
        )}</span>`;
      }
    }

    // Update full progress bar
    const fill = bar.querySelector(".fsb-fill");
    if (fill) fill.style.setProperty("--fsb-pct", pct.toFixed(1) + "%");

    // Update mini progress bar
    const miniFill = bar.querySelector(".fsb-mini-fill");
    if (miniFill) miniFill.style.setProperty("--fsb-pct", pct.toFixed(1) + "%");

    // Update ARIA
    const track = bar.querySelector(".fsb-track");
    if (track) track.setAttribute("aria-valuenow", Math.round(pct));
  }

  // ── Fetch cart ───────────────────────────────────────────────────────────

  async function fetchCartAndUpdate() {
    try {
      const res = await fetch("/cart.js", { cache: "no-store" });
      const data = await res.json();
      updateBar(data.total_price);
    } catch (e) {
      console.warn("[free-shipping-bar] Could not fetch cart:", e);
    }
  }

  // ── Touch toggle (mobile) ────────────────────────────────────────────────

  function initToggle() {
    const bar = document.querySelector("free-shipping-bar");
    if (!bar) return;

    const trigger = bar.querySelector(".fsb-trigger");
    if (!trigger) return;

    // On touch devices, tap trigger opens/closes the popover
    trigger.addEventListener("click", function (e) {
      if (!window.matchMedia("(hover: hover)").matches) {
        const isOpen = bar.dataset.open === "true";
        bar.dataset.open = isOpen ? "false" : "true";
        trigger.setAttribute("aria-expanded", String(!isOpen));
        e.stopPropagation();
      }
    });

    // Close on outside tap
    document.addEventListener("click", function () {
      if (bar.dataset.open === "true") {
        bar.dataset.open = "false";
        trigger.setAttribute("aria-expanded", "false");
      }
    });
  }

  // ── Cart event listeners ─────────────────────────────────────────────────

  [
    "cart:refresh",
    "cart:updated",
    "cart:change",
    "cart-update",
    "on:cart:update",
  ].forEach((evt) => {
    document.addEventListener(evt, fetchCartAndUpdate);
  });

  // Intercept fetch calls to cart mutation endpoints
  (function patchFetch() {
    const _fetch = window.fetch;
    window.fetch = function (...args) {
      const url = (args[0] && (args[0].url || args[0])) || "";
      const result = _fetch.apply(this, args);
      if (/\/cart\/(add|change|update|clear)(\.js)?/.test(url)) {
        result
          .then((res) => res.clone().json())
          .then((data) => {
            if (data && typeof data.total_price === "number") {
              updateBar(data.total_price);
            } else {
              fetchCartAndUpdate();
            }
          })
          .catch(() => fetchCartAndUpdate());
      }
      return result;
    };
  })();

  // ── Init ─────────────────────────────────────────────────────────────────

  function init() {
    initToggle();
    fetchCartAndUpdate();
    // Enable collapse transitions only after the first paint so the initial
    // eligible state renders without animation.
    const bar = document.querySelector("free-shipping-bar");
    if (bar) {
      requestAnimationFrame(() =>
        requestAnimationFrame(() => bar.classList.add("fsb-ready")),
      );
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
